import { useMemo } from 'react';

export function useContentVisibility() {
  return useMemo(() => {
    const visibility = (window as any).contentVisibility ?? {};

    return {
      showTeamLogos: Boolean(visibility.showTeamLogos),
      showStudentAthletes: Boolean(visibility.showStudentAthletes),
    };
  }, []);
}
